//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";

import iconCalendar from "../../../images/icons/icon_calendar_full.svg";

class GeneralToast extends PolymerElement {
  static get template() {
    return html`
      <style>
      #toast {
        visibility: visible;
        margin: auto;
        color: #fff;
        border-radius: 8px;
        position: fixed;
        z-index: 150;
        left: 0;
        right: 0;
        top: 160px;
      }

      .content-container {
        padding: 16px;
        border-radius: 8px;
      }

      .green {
        background-color: #007C41 !important;
      }

      .red {
        background-color: #D0021B !important;
      }

      .black {
        background-color: #424242 !important;
      }

      .green .title-container {
        display: flex;
        align-items: center;
      }

      .green img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        float: left;
      }
      .green h2 {
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        margin: 0;
      }
      .description {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        margin: 0;
        color: #FFFFFF;
      }

        .show {
          transform: translateY(0);
          transition: all 0.5s cubic-bezier(0.68, -0.55, 0.25, 1.35);
        }
        .hide {
          transform: translateY(calc(-100vh - 170px));
          transition: all 0.5s cubic-bezier(0.68, -0.55, 0.25, 1.35);
        }

        /* Modal Content */
        .modal-content {
          height: auto;
          color: #FFFFFF;
          background-color: #007C41;
          box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
          position: relative;
          z-index: 100;
          margin: 0 auto 0;
          /* 15% from the top and centered */
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
        }

        .header {
          display: flex !important;
          align-items: center;
          justify-content: flex-start;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          margin: -15px 8px -15px;
        }
        .header img {
          width: 16px;
          height: 16px;
        }
        .content-link {
          display: flex;
          color: #FFFFFF;
          justify-content: flex-start;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          margin: 0px 8px;
        }
      </style>
      <div id="toast" class$="[[getContainerClass(isActive)]]" style$="[[containerStyle]]">
        <div class$="content-container" on-click="handleCloseModal">
          <div class$="modal-content [[color]]" style$="[[_contentStyle(contentStyle)]]">
            <template is="dom-if" if="[[isShowTopText]]">
              <div class="header">
                <img src="[[iconCalendar]]" alt="alomedika" />
                <h4>&nbsp [[title]]</h4>
              </div>
            </template>
            <div class="content-link">
              <p class="description" style$="[[_bodyStyle(bodyStyle)]]">{{body}} <strong>{{bodyBold}}</strong></p>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      iconCalendar: {
        type: String,
        value: iconCalendar,
      },    
      isActive: {
        type: Boolean,
        value: false,
        notify: true,
      },
      body: {
        type: String,
      },
      bodyBold: {
        type: String,
      },
      isShowTopText: {
        type: Boolean,
        value: false,
      },
      color: {
        type: String,
      },
      title: {
        type: String,
      },
      containerStyle: {
        type: String,
      },
      contentStyle: {
        type: String,
        value: "width: 736px; padding: 16px;",
      },
      bodyStyle: {
        type: String,
      },
    };
  }

  // Apply dynamic width and padding to the inner toast content box.
  _contentStyle(contentStyle) {
    return contentStyle;
  }

  // Control how body text wraps and aligns inside the toast.
  _bodyStyle(bodyStyle) {
    return bodyStyle;
  }

  handleCloseModal() {
    this.isActive = false;
  }

  getContainerClass(isActive) {
    setTimeout(() => {
      this.isActive = false;
    }, 5000);
    return isActive ? "show" : "hide";
  }

  ready() {
    super.ready()
  }

}
customElements.define("general-toast", GeneralToast);
